<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="567">
    <v-form ref="form" class="px-12 pt-9 pb-7 white">
      <v-row class="pb-12">
        <v-col cols="12">
          <p class="primary--text font-weight-bold mb-2">
            SOLICITAÇÃO PARA SEGURADORA
          </p>
        </v-col>
        <v-col cols="12">
          <BaseFormTextArea
            id-element="reasonCancelEndorsement"
            placeholder="Inserir"
            v-model="form.consideracoes_lockton"
            :rules="[maxLengthTextArea]"
            label-text="Considerações Adicionais"
          />
        </v-col>
        <v-col cols="12" class="pb-1">
          <p class="primary--text mb-2 body-2 font-weight-bold">
            Anexar documentos (se necessários)
          </p>
          <DropFile @selected-files="addFiles" :multiple="true" class="mb-5" />
          <DocumentDataTable
            v-if="form.anexos.length > 0"
            :documents="form.anexos"
            @preview-file="onPreviewFile"
            @remove-file="onRemoveFile"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="5" sm="3">
          <BaseButton
            v-html="'CANCELAR'"
            color="secondary"
            outlined
            width="100%"
            @click="closeModal"
          />
        </v-col>
        <v-col cols="5" sm="3" class="ml-5">
          <BaseButton
            v-html="'ENVIAR'"
            class="secondary"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>
<script>
import { requiredInput, maxLengthTextArea } from "@/utils/rules.js";
import DocumentDataTable from "@/components/DocumentDataTable";
import DropFile from "@/components/DropFile";
import { FILE } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
export default {
  data: () => ({
    form: {
      consideracoes_lockton: null,
      anexos: []
    },
    requiredInput,
    maxLengthTextArea
  }),
  components: {
    DocumentDataTable,
    DropFile
  },
  mixins: [DocumentsMixin],
  methods: {
    closeModal() {
      this.$emit("close");
    },
    submit() {
      this.$emit("submit", this.form);
    },
    addFiles(files) {
      this.form.anexos = this.form.anexos.concat(
        files.map(file => ({
          arquivo: {
            [FILE]: file,
            nome: file.name
          }
        }))
      );
    },
    onRemoveFile(item) {
      this.form.anexos = this.form.anexos.filter(
        document => document.arquivo !== item.arquivo
      );
    }
  }
};
</script>
<style lang="sass"></style>
